export const mainRoutes = {
  label: 'Principale',
  labelDisable: true,
  children: [
    {
      name: 'Squadra',
      icon: 'users',
      to: '/team',
      active: true
    },
    {
      name: 'Classe',
      icon: 'graduation-cap',
      to: '/classe',
      active: true
    },
    {
      name: 'Classifica',
      icon: 'trophy',
      to: '/ranking',
      active: true
    },
    {
      name: 'Attività',
      icon: 'history',
      to: '/feed',
      active: true
    }
  ]
};

export const fantaclasseRoutes = {
  label: 'FantaClasse',
  children: [
    {
      name: 'Domande Frequenti',
      icon: 'comments',
      to: '/faq',
      active: true
    },
    {
      name: 'Guida Capoclasse',
      icon: 'book',
      to: '/guide',
      active: true,
      prefect: true // Only prefect can see this
    }
  ]
};

export default [mainRoutes, fantaclasseRoutes];
